import { render, staticRenderFns } from "./FlightStatusSearchboxAirline.vue?vue&type=template&id=9b524d96"
import script from "./FlightStatusSearchboxAirline.vue?vue&type=script&lang=js"
export * from "./FlightStatusSearchboxAirline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports